import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./register-service-worker";
import "./styles.css";

const rootElement = globalThis.document?.getElementById("root") ?? null;

rootElement
  ? createRoot(rootElement).render(
      <StrictMode>
        <App />
      </StrictMode>
    )
  : null;
